import PropTypes from "prop-types";

import OptInFormCMP from "@/components/forms/OptInForm";

import { Header } from "../Header";

import styles from "./OptInForm.module.scss";

const OptInForm = ({ handleBack, currentJob, handleFileChange, handleSubmit }) => {
  return (
    <>
      <Header handleBack={handleBack} currentJob={currentJob} />

      <h2 className={styles.subtitle}>
        Awesome! We`re glad you`re interested in this opportunity. As a next step, please take the
        time to fill out the questions below. Keep in mind, these will be shared with the hiring
        committee.
      </h2>

      <OptInFormCMP
        onFileChange={handleFileChange}
        onCancel={handleBack}
        onSubmit={handleSubmit}
        currentJob={currentJob}
      />
    </>
  );
};

OptInForm.propTypes = {
  handleBack: PropTypes.func,
  currentJob: PropTypes.any,
  handleFileChange: PropTypes.func,
  handleSubmit: PropTypes.func
};

export { OptInForm };
